import { IImportHandler } from '../import-handler.interface';
import { ErrorCodes, FileModel } from '@shared';
import { WorkspaceDatabaseProvider } from '@database/workspace';
import { LoggingService } from '@shared/logging';
import { WorkspaceRepository } from '@database/central';

export class ConfigSchemaGeneratorHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private workspaceDatabaseProvider: WorkspaceDatabaseProvider,
		private loggingService: LoggingService,
		private workspaceRepository: WorkspaceRepository
	) {}

	public async cleanup(model: FileModel): Promise<void> {
		await this.workspaceRepository.remove(model.workFileId);
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		if (model.workFileId === null || model.workFileId === undefined) {
			throw new Error('The workfile has no id assigned.');
		}
		try {
			await this.workspaceDatabaseProvider.initializeDatabase(model.workFileId);
		} catch (error) {
			this.loggingService.error(ErrorCodes.ConfigSchemaGeneratorHandler, error);
			await this.cleanup(model);
			throw error;
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}

	//todo: add a cleanUp method that will undo whatever was done at this step
}
